import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { CreateReturnComponent } from '../custom-return/create-return/create-return.component';
import { MyAccountComponent } from '../custom-return/my-account/my-account.component';
import { ReturnHistoryComponent } from '../custom-return/return-history/return-history.component';
import { NoMouseScrollModule } from '../shared/directives/no-mouse-scroll/no-mouse-scroll.module';
import { NeedAssistanceModule } from '../shared/modules/need-assistance/need-assistance.module';
import { ProductSearchModule } from '../shared/modules/product-search/product-search.module';
import { ReturnSearchModule } from "../shared/modules/return-search/return-search/return-search.module";
import { ReturnDashboardComponent } from './return-dashboard/return-dashboard.component';

@NgModule({
  declarations: [
    ReturnDashboardComponent,
    CreateReturnComponent,
    ReturnHistoryComponent,
    MyAccountComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    NgbModule,
    ProductSearchModule,
    NeedAssistanceModule,
    NgbPopoverModule,
    NgbTooltipModule,
    FormsModule,
    ReturnSearchModule,
    NoMouseScrollModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CreateReturnMainJspComponent: {
          component: ReturnDashboardComponent,
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideOutlet({
      id: 'CreateReturnMainContentSlotName',
      position: OutletPosition.REPLACE,
      component: ReturnDashboardComponent,
    })
  ]
})
export class ReturnModule { }
